const entirety = {
  state: {
    headerSelect1Active: 0,
    module: '',
    title: '',
    header: '',
    type: '',
    typeName: '',
    kind: '',
    kindName: '',
    channel: '',
    channelName: '',
    quota: '',
    quotaName: '',
    time: '2',
    timeName: '月',
    loadFlag: false,
    tabletype: null, // 1是产品分析  2是结构分析
    pageFlag: null,
    careDesc: '', //  关注的描述
    pathId: '', //  关注调整条件
    descTitle: '', //  接收的描述title
    calendarDate: '', //  详情页传递的日历
    channelQuota: [],
    mainProductList: {},
    classification: ''
  },
  mutations: {
    SET_MODULE_TYPE: (state, type) => {
      state.module = type
    },
    // 整体指标卡片的名称
    SET_TITLE_TYPE: (state, type) => {
      state.title = type
    },
    // 判断整体的产品分析还是结构分析页面  传入true  false
    ENTIRETY_SET_HEADER: (state, type) => {
      state.header = type
    },
    // 判断整体中第一个筛选条件的激活状态
    ENTIRETY_SET_HeaderSelect1Active: (state, type) => {
      state.headerSelect1Active = type
    },
    // 整体预收指标  考核指标id
    ENTIRETY_SET_TYPE: (state, type) => {
      state.type = type
    },
    // 整体指标名称
    ENTIRETY_SET_TYPE_NAME: (state, typeName) => {
      state.typeName = typeName
    },
    // 整体类型id
    ENTIRETY_SET_KIND: (state, kind) => {
      state.kind = kind
    },
    // 整体类型名称
    ENTIRETY_SET_KIND_NAME: (state, kindName) => {
      state.kindName = kindName
    },
    // 整体指标卡片id
    ENTIRETY_SET_QUOTA: (state, quota) => {
      state.quota = quota
    },
    // 整体指标卡片名称
    ENTIRETY_SET_QUOTA_NAME: (state, quotaName) => {
      state.quotaName = quotaName
    },
    // 整体指标详情页渠道id
    ENTIRETY_SET_CHANNEL: (state, channel) => {
      state.channel = channel
    },
    // 整体指标详情页渠道名称
    ENTIRETY_SET_CHANNEL_NAME: (state, channelName) => {
      state.channelName = channelName
    },
    // 整体指标详情页时间类型  1日  2月  3年
    ENTIRETY_SET_TIME: (state, type) => {
      state.time = type
    },
    // 整体指标详情页时间类型名称  日  月  年
    ENTIRETY_SET_TIME_NAME: (state, timeName) => {
      state.timeName = timeName
    },
    // 整体指标详情页表格类型
    ENTIRETY_SET_TABLETYPE: (state, tabletype) => {
      state.tabletype = tabletype
    },
    // 判断是否为指标详情页
    ENTIRETY_SET_PAGEFLAG: (state, pageFlag) => {
      state.pageFlag = pageFlag
    },
    // 整体指标页面loading图片显示隐藏
    ENTIRETY_SET_FLAG: (state, type) => {
      state.loadFlag = type
    },
    // 跳转详情页描述
    ENTIRETY_SET_CAREDESC: (state, type) => {
      state.careDesc = type
    },
    // 详情页判断指标
    ENTIRETY_SET_PATHID: (state, type) => {
      state.pathId = type
    },
    // 详情页url接收的title描述
    ENTIRETY_SET_TITLE: (state, type) => {
      state.descTitle = type
    },
    // 详情页日历选择的时间
    ENTIRETY_SET_CALENDAR: (state, type) => {
      state.calendarDate = type
    },
    // 渠道指标变化
    ENTIRETY_SET_CHANNEL_QUOTA: (state, type) => {
      state.channelQuota = type
    },
    // 主销产品
    MAIN_PRODUCT_LIST: (state, type) => {
      state.mainProductList = type
    },
    // 指标类别 导入指标|应用指标
    ENTIRETY_SET_ClASSIFICATION: (state, classification) => {
      state.classification = classification
    }
  },
  actions: {
    GetFlag: ({ commit }, type) => {
      commit('ENTIRETY_SET_PAGEFLAG', type)
    }
  }
}
export default entirety



// WEBPACK FOOTER //
// ./src/store/modules/entirety.js